import axiosInstance from '../axiosInstance';

const uploadPlayers = async (fileName, eventId) => {
  return axiosInstance.post('/player/upload', { fileName, eventId }).then((response) => {
    return response.data;
  });
};

const downloadTemplate = async (eventId) => {
  return axiosInstance
    .get(`/player/template/${eventId}`, { responseType: 'blob' })
    .then((response) => {
      return response.data;
    });
};

const addPlayerToEvent = async (eventId, player) => {
  return axiosInstance.post(`/player/add/${eventId}`, player).then((response) => {
    return response.data;
  });
};

const updatePlayerFromEvent = async (eventId, player) => {
  return axiosInstance.put(`/player/update/${eventId}`, player).then((response) => {
    return response.data;
  });
};

const updatePlayerStatus = async (eventId, playerId, status, reason) => {
  return axiosInstance
    .put(`/player/status/${eventId}/${playerId}`, { status, reason })
    .then((response) => {
      return response.data;
    });
};

const removePlayerFromEvent = async (eventId, playerId) => {
  return axiosInstance.delete(`/player/remove/${eventId}/${playerId}`).then((response) => {
    return response.data;
  });
};

const swapPlayer = async (eventId, oldPlayerId, newPlayer) => {
  return axiosInstance
    .put(`/player/swap/${eventId}`, { oldPlayerId, newPlayer })
    .then((response) => {
      return response.data;
    });
};

// The member sync runs as a background job: it takes minutes, so starting it
// returns a job id straight away and the caller polls for progress.
const startMemberSync = async (dryRun = false) => {
  return axiosInstance.post('/player/sync-bsa', { dryRun }).then((response) => {
    return response.data;
  });
};

const getMemberSyncJob = async (jobId) => {
  return axiosInstance.get(`/player/sync-bsa/${jobId}`).then((response) => {
    return response.data;
  });
};

// The job still running, or the most recent one - so a reload mid-sync picks the
// progress back up. `job` is null when no sync has run yet.
const getLatestMemberSync = async () => {
  return axiosInstance.get('/player/sync-bsa').then((response) => {
    return response.data;
  });
};

const playerService = {
  uploadPlayers,
  downloadTemplate,
  addPlayerToEvent,
  removePlayerFromEvent,
  updatePlayerFromEvent,
  updatePlayerStatus,
  swapPlayer,
  startMemberSync,
  getMemberSyncJob,
  getLatestMemberSync
};

export default playerService;
